var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overlay-button",class:{ default: _vm.type === 'default', success: _vm.type === 'success' },on:{"click":function($event){return _vm.$emit('click')}}},[_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon,"size":_vm.iconSize}}),_c('div',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }